<template>
    <v-menu v-model="runningAppsMenuOpen" offset-y>
        <template v-slot:activator="{ on: menuOn }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltipOn }">
                    <v-btn
                        v-on="{ ...menuOn, ...tooltipOn }"
                        class="px-3"
                        min-width="0"
                        :input-value="runningAppsMenuOpen"
                        active-class="primary--text"
                        e2e-toolbar-running-apps>
                        <v-badge v-if="runningDeployments.length" :content="runningDeployments.length" color="primary" overlap>
                            <v-icon small>mdi-monitor</v-icon>
                        </v-badge>
                        <v-icon small v-else>mdi-monitor</v-icon>
                    </v-btn>
                </template>
                <span>Applications</span>
            </v-tooltip>
        </template>
        <v-list dense min-width="200">
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title class="secondary--text subtitle-1 font-weight-bold">Running</v-list-item-title>
                    <v-list-item-subtitle>{{ runningDeployments.length }} applications</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider v-if="runningDeployments.length" class="mt-3 mb-3"></v-divider>
            <v-list-item-group color="secondary">
                <v-tooltip bottom v-for="app in runningDeployments" :key="app.aid">
                    <template v-slot:activator="{ on }">
                        <v-list-item v-on="on" :to="{ name: 'app-open', params: { oid: app.oid, sid: app.sid, iid: app.iid, snid: app.snid, aid: app.aid } }">
                            <v-list-item-avatar>
                                <img :src="appIcon(app)" />
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title class="d-flex align-center">
                                    <h4 class="secondary--text mr-2">{{ app.name }}</h4>
                                    <v-chip v-if="app.shared === 'true'" small outlined>shared</v-chip>
                                </v-list-item-title>
                                <v-list-item-subtitle>{{ app.description }}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <stop-application :app="app" :appName="app.name" :isShared="app.shared === 'true'" :sessionId="app.session_id">
                                    <v-btn color="secondary" icon>
                                        <v-icon dark>mdi-stop</v-icon>
                                    </v-btn>
                                </stop-application>
                            </v-list-item-action>
                        </v-list-item>
                    </template>
                    <div class="d-flex flex-column caption">
                        <span>
                            Space:
                            <span class="font-weight-bold text-uppercase">{{ app.space_long_id }}</span>
                        </span>
                        <span>
                            Instance:
                            <span class="font-weight-bold text-uppercase">{{ app.instance_long_id }}</span>
                        </span>
                    </div>
                </v-tooltip>
            </v-list-item-group>
        </v-list>

        <v-divider></v-divider>
    </v-menu>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { appTypeAndImageLink } from '@/mixins/appTypeAndImage'

const StopApplication = () => import('@/modules/application/components/TheApplicationStopDialog.vue')

export default {
    components: {
        StopApplication
    },
    mixins: [appTypeAndImageLink],
    props: {
        collapsed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            runningAppsMenuOpen: false
        }
    },
    computed: {
        ...mapGetters('appStore', ['runningDeployments']),
        ...mapState(['userInfo'])
    },
    watch: {
        userInfo: {
            async handler(user) {
                if (user) {
                    this.$store.dispatch('userStore/fetchRunningUserTasks')
                }
            },
            immediate: true
        }
    }
}
</script>
